/**
 * Poupança de tempo estimada: documentar um passo à mão (captura, recorte, anotação e
 * legenda) leva, como referência, cerca de 120 segundos; com a extensão é um clique.
 * É uma ESTIMATIVA (passos × 120 s), nunca uma medição: a apresentação diz sempre
 * «estimada». Conta os passos de ação documentados (os blocos de texto não contam).
 */
export const SECONDS_SAVED_PER_STEP = 120;

export const savedSeconds = (steps: number) =>
  Math.max(0, Math.round(steps)) * SECONDS_SAVED_PER_STEP;
